module.exports = __webpack_public_path__ + "img/stock4.6ab6e9a9.png";